// OCR engine served from this app (public/tesseract) — no third-party CDN, works offline once cached
export async function createOcrWorker(logger) {
  const { createWorker } = await import("tesseract.js");
  const base = `${window.location.origin}${process.env.PUBLIC_URL || ""}/tesseract`;
  return createWorker("eng", 1, { workerPath: `${base}/worker.min.js`, corePath: `${base}/core`, langPath: `${window.location.origin}${process.env.PUBLIC_URL || ""}/tesseract-lang`, workerBlobURL: false, ...(logger ? { logger } : {}) });
}
